import {
    GraduationAdminFiltersInput,
    GraduationAdminExportFiltersInput,
    GraduationAdminResponse,
} from "../../../types/api/admin/graduation";
import { request } from "../../apiService";

export const getAdminGraduation = async (
    input: GraduationAdminFiltersInput
) => {
    return await request<GraduationAdminResponse, GraduationAdminFiltersInput>(
        "/v3/admin/graduation",
        {
            input,
        }
    );
};

export const getAdminGraduationExport = async (
    input: GraduationAdminExportFiltersInput
) => {
    return await request<string, GraduationAdminExportFiltersInput>(
        "/v3/admin/graduation/export",
        {
            input,
        }
    );
};

export const validateAdminGraduation = async (userId: string) => {
    return await request(`/v3/admin/graduation/${userId}/validate`, {
        method: "POST",
    });
};

export type PromoteEligibleResponse = {
    success: boolean;
    promotionId: string;
    promotionName: string;
    eligibleCount: number;
    promotedCount: number;
    failedCount: number;
    promoted: Array<{ userId: string; roleName?: string }>;
    failed: Array<{ userId: string; error: string }>;
};

export const promoteEligibleAdminGraduation = async (promotionId: string) => {
    return await request<PromoteEligibleResponse, { promotionId: string }>(
        "/v3/admin/graduation/promote-eligible",
        {
            method: "POST",
            input: { promotionId },
        }
    );
};

export const cancelAdminGraduationValidation = async (userId: string) => {
    return await request(`/v3/admin/graduation/${userId}/validate`, {
        method: "DELETE",
    });
};
